import React, { useState } from 'react';

import { Button, Modal, Form } from 'react-bootstrap';

import db from 'service/db'

function UpdateModal({ data = {}, btnTitle }) {
    const [rowData, setRowData] = useState(data);
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setRowData({ ...data })
        setShow(false)
    };
    const handleShow = () => setShow(true);

    async function confirmFunction() {
        if (rowData.src) {
            if (data.id) {
                await db.putImage(rowData)
            } else {
                await db.postImage(rowData)
            }
            handleClose();
            alert("완료 되었습니다.")
            window.location.reload()
        } else {
            alert("값을 확인해 주세요")
        }
    }

    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                {btnTitle}
            </Button>

            <Modal show={show} onHide={handleClose} animation={false} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{btnTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Image URL</Form.Label>
                            <Form.Control className="mb-1" type="text" placeholder="Image URL" value={rowData.src} onChange={(e) => { setRowData({ ...rowData, 'src': e.target.value }) }} />
                        </Form.Group >
                        <Form.Group className="mb-3">
                            <Form.Label>Link URL</Form.Label>
                            <Form.Control className="mb-1" type="text" placeholder="Link URL" value={rowData.link} onChange={(e) => { setRowData({ ...rowData, 'link': e.target.value }) }} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
                            <Form.Select className="mb-1" type="text" placeholder="Category" defaultValue="Main" value={rowData.category} onChange={(e) => { setRowData({ ...rowData, 'category': e.target.value }) }}>
                                <option value="main">Main</option>
                                <option value="sub">Sub</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={confirmFunction}>
                        {data.id ? "Update" : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UpdateModal;